// extracted by mini-css-extract-plugin
export default {"root":"_2QxM9","warning":"_3pQoe"};